import axios from "axios";
import { warehouseActions } from "../../../store/slices/warehouse";
import { workerActions } from "../../../store/slices/workers";

// Warehouse map (keyed by messageId) caching the full original body of each
// message, fetched on demand from the BlockStore-backed body endpoint. Using a
// single map id lets us drop every cached body with one unload on cleanup.
export const messageBodiesDataId = "teamsMessageBodies";

// Worker id namespaced per message so several bodies can load in parallel and
// be cleared as a group with the "getMessageBody-" prefix.
export const getMessageBodyId = (messageId) => `getMessageBody-${messageId}`;

// Fetches the full original body of a channel message from
// GET /mailapi/teams/channel/message/{messageID}/body and caches it in the
// warehouse keyed by messageId.
const getMessageBody = ({ M365server, cloner_key, messageId, controller }) => {
  const id = getMessageBodyId(messageId);

  return async (dispatch) => {
    dispatch(workerActions.start(id));
    try {
      const url = `${M365server}mailapi/teams/channel/message/${messageId}/body`;
      const response = await axios.get(url, {
        signal: controller?.signal,
        headers: { cloner_key },
      });

      // 200 with a MessageBodyDTO { content, content_type }. The endpoint may
      // answer 204 with an empty body (no backed-up body); axios returns "" in
      // that case, which we cache as an explicit empty marker so we neither
      // re-fetch it nor try to render it.
      const data = response.data;
      if (data && typeof data === "object" && "content" in data) {
        dispatch(
          warehouseActions.add({
            id: messageBodiesDataId,
            key: messageId,
            data,
          })
        );
      } else {
        dispatch(
          warehouseActions.add({
            id: messageBodiesDataId,
            key: messageId,
            data: { content: "", content_type: "", empty: true },
          })
        );
      }

      dispatch(workerActions.finish({ id }));
    } catch (e) {
      if (e.code === "ERR_CANCELED") {
        dispatch(workerActions.clear(id));
        return;
      }
      console.error(e);
      dispatch(workerActions.finish({ id, error: e.message }));
    }
  };
};

export default getMessageBody;
